import Instance from "../../../../Axios";

// New Actions for the app

const DeleteWorkPermit = (idwp) => async (dispatch) => {
  await Instance()
    .put(`/construcoes/workpermits/workpermit/${idwp}/delete`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "DELETE_WORK_PERMIT", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeleteWorkPermit;
